'use client';

import RichText from 'components/rich-text';
import { Link } from 'src/navigation';
import PropTypes from 'prop-types';
import styles from './quotes-module.module.scss';
import LinkButton from 'components/controls/links/link-button';

const QuotesModule = (props) => {
	const { title, quotes, viewMoreCTA, viewMoreUrl } = props;
	return (
		<div className={styles.quotesModule}>
			<div className={styles.contents}>
				<div className={styles.header}>
					<h2>{title}</h2>
					{viewMoreUrl && (
						<h4>
							<LinkButton href={viewMoreUrl} text={viewMoreCTA} />
						</h4>
					)}
				</div>
				<div className={styles.quotes}>
					{quotes?.map((quote, i) => {
						return (
							<figure
								/* eslint-disable react/no-array-index-key -- TODO: Find an alternative key value. */
								key={`${quote.quoteAttributionName}-${i}`}
								/* eslint-enable react/no-array-index-key */
								className={styles.quote}
							>
								<blockquote cite="#" className={styles.quoteText}>
									<RichText value={quote.quoteBody} />
								</blockquote>
								<figcaption className={styles.quoteCitation}>
									{quote.quoteAttributionUrl ? (
										<Link
											className={styles.quoteLink}
											href={quote.quoteAttributionUrl}
										>
											{quote.quoteAttributionName}
										</Link>
									) : (
										quote.quoteAttributionName
									)}
								</figcaption>
							</figure>
						);
					})}
				</div>
			</div>
		</div>
	);
};

QuotesModule.propTypes = {
	quotes: PropTypes.array,
	title: PropTypes.string,
	viewMoreCTA: PropTypes.string,
	viewMoreUrl: PropTypes.string,
};

export default QuotesModule;
